module.exports = __webpack_public_path__ + "static/equity-e0ae30b2fc956f45006befb2b9dbb70d.png";